import PropTypes from "prop-types";
import * as React from "react";
import {
  Badge,
  BlockIcon,
  CheckCircleIcon,
  LiveIcon,
  VisibilityIcon,
  WarningIcon,
} from "../../themeV2";
import css from "./ShopInfo.module.css";
import { badgeStatusOf, tonePropType } from "./tones";

const ICONS = {
  open: CheckCircleIcon,
  closed: BlockIcon,
  live: LiveIcon,
  hidden: VisibilityIcon,
  problem: WarningIcon,
};

export default function StatusChips({ chips }) {
  if (chips.length === 0) {
    return null;
  }

  return (
    <ul className={css.chipList}>
      {chips.map(({ key, label, tone, icon }) => {
        const Icon = ICONS[icon] ?? ICONS.problem;

        return (
          <li key={key}>
            <Badge
              variant="status"
              status={badgeStatusOf(tone)}
              className={css.chip}
            >
              <Icon aria-hidden="true" />
              {label}
            </Badge>
          </li>
        );
      })}
    </ul>
  );
}

StatusChips.propTypes = {
  chips: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      tone: tonePropType,
      icon: PropTypes.oneOf(Object.keys(ICONS)),
    }),
  ).isRequired,
};
